import React, { useState } from "react";
import TagSelectPopover, { TagSelectOption } from "./TagSelectPopover";

const OPTIONS: TagSelectOption[] = [
	{ key: "green", name: "Godkänd", color: "#61bd4f" },
	{ key: "yellow", name: "Dinuka", color: "#f2d600" },
	{ key: "orange", name: "Hypercare", color: "#ff9f1a" },
	{ key: "red", name: "PRIO", color: "#eb5a46" },
	{ key: "blue", name: "Att gå igenom", color: "#0079bf" },
	{ key: "purple", name: "Refined", color: "#c377e0" },
	{ key: "nocolor", name: "Utan färg" },
];

const TagSelectPopoverExample: React.FC = () => {
	const [selected, setSelected] = useState<string[]>(["red"]);

	return (
		<div className="space-y-8 p-6">
			<div>
				<h3 className="mb-4 text-lg font-semibold">TagSelectPopover Example</h3>

				<div className="space-y-4">
					<div className="flex flex-wrap items-center gap-1.5">
						{selected.length === 0 ? (
							<p className="text-sm text-gray-500">Inga taggar tilldelade.</p>
						) : (
							selected.map((key) => {
								const o = OPTIONS.find((opt) => opt.key === key)!;
								return (
									<span
										key={key}
										className="rounded px-3 py-1 text-sm font-medium"
										style={{ backgroundColor: o.color || "#e5e7eb" }}
									>
										{o.name}
									</span>
								);
							})
						)}
					</div>

					<TagSelectPopover
						options={OPTIONS}
						selectedKeys={selected}
						onSelect={(key) => setSelected((prev) => [...prev, key])}
						onDeselect={(key) => setSelected((prev) => prev.filter((k) => k !== key))}
					/>

					<p className="text-sm text-gray-600">Selected: {selected.join(", ") || "none"}</p>
				</div>
			</div>
		</div>
	);
};

export default TagSelectPopoverExample;
